<section class="plan-list">
  <header class="plan-list-header">
    <section
      class="plan-list-header-strategy-selector"
      [class.seat-based]="billingStrategy === BillingStrategy.SEAT_BASED"
      *ngIf="supportSeatBasedPlans"
    >
      <div
        class="plan-list-header-strategy-selector-button"
        [class.selected]="billingStrategy === BillingStrategy.USAGE_BASED"
        (click)="handleBillingStrategyChange(BillingStrategy.USAGE_BASED)"
        data-name="plan-list-header-usage-strategy-btn"
      >
        {{ 'Pay per usage' | translate }}
      </div>
      <div
        class="plan-list-header-strategy-selector-button"
        [class.selected]="billingStrategy === BillingStrategy.SEAT_BASED"
        (click)="handleBillingStrategyChange(BillingStrategy.SEAT_BASED)"
        data-name="plan-list-header-seat-strategy-btn"
      >
        {{ 'Pay per seat' | translate }}
      </div>
    </section>
    <section
      class="plan-list-header-frequency-toggle"
      *ngIf="billingStrategy === BillingStrategy.SEAT_BASED && supportAnnualPlans"
    >
      <mat-slide-toggle
        [checked]="billingFrequency === BillingFrequency.Annually"
        (change)="handleBillingFrequencyChange($event)"
        class="custom-mat-toggle"
        data-name="plan-list-header-frequency-toggle-input"
      ></mat-slide-toggle>
      <span [class.current-frequency]="billingFrequency === BillingFrequency.Monthly">
        {{ 'Monthly' | translate }}
      </span>
      <div class="plan-list-header-frequency-toggle-text-separator"></div>
      <span [class.current-frequency]="billingFrequency === BillingFrequency.Annually">
        {{ 'Annually' | translate }}
      </span>
    </section>
  </header>

  <main class="plan-list-cards">
    <app-plan-card
      class="plan-list-cards-item"
      *ngFor="let plan of plans"
      [plan]="plan"
      [currentPlan]="currentPlan"
      [isInstitutionUser]="isInstitutionUser"
      [billingFrequency]="billingFrequency"
      (billingFrequencyChange)="handleBillingFrequencyChange($event)"
    ></app-plan-card>
  </main>

  <section class="plan-list-compare-plans-button-container">
    <app-pencil-button
      class="plan-list-compare-plans-button"
      [theme]="PencilButtonThemeEnum.SECONDARY_OUTLINE"
      [label]="'See full comparison' | translate"
      [icon]="'expand_more'"
      [iconConfig]="{ type: IconTypes.matIcon }"
      [iconOnLeft]="false"
      buttonType="button"
      (clickEvent)="scrollToComparison()"
      data-name="plan-list-see-full-comparison-btn"
    ></app-pencil-button>
  </section>

  <section *ngIf="isComparePlans$ | async" class="plan-list-table-scroller" #planListTable>
    <div class="plan-list-table" [style.--plan-table-plan-count]="plans.length || 4">
      <!-- Sticky header row -->
      <div class="plan-list-table-row header">
        <div class="plan-list-table-cell label"></div>
        <div
          class="plan-list-table-cell plan-header"
          *ngFor="let plan of plans"
          [class.highlighted]="isHighlightedPlan(plan)"
        >
          <app-plan-card
            [plan]="plan"
            [currentPlan]="currentPlan"
            [isMiniView]="true"
            [isInstitutionUser]="isInstitutionUser"
            [billingFrequency]="billingFrequency"
            (billingFrequencyChange)="handleBillingFrequencyChange($event)"
          ></app-plan-card>
        </div>
      </div>

      <ng-container
        *ngTemplateOutlet="categoryRows; context: { categories: displayedCategories }"
      ></ng-container>
    </div>
  </section>

  <section *ngIf="isComparePlans$ | async" class="plan-list-compare-plans-button-container">
    <app-pencil-button
      class="plan-list-compare-plans-button compact"
      [theme]="PencilButtonThemeEnum.SECONDARY_OUTLINE"
      [label]="((isFullComparison$ | async) ? 'Show less' : 'Show full comparison') | translate"
      [icon]="(isFullComparison$ | async) ? 'expand_less' : 'expand_more'"
      [iconConfig]="{ type: IconTypes.matIcon }"
      [iconOnLeft]="false"
      buttonType="button"
      (clickEvent)="toggleFullComparison()"
      data-name="plan-list-show-full-comparison-btn"
    ></app-pencil-button>
  </section>
</section>

<ng-template #categoryRows let-categories="categories">
  <ng-container *ngFor="let category of categories">
    <div class="plan-list-table-row section">
      <div class="plan-list-table-cell label section-label">{{ category.value }}</div>
      <div
        class="plan-list-table-cell section-spacer"
        *ngFor="let plan of plans"
        [class.highlighted]="isHighlightedPlan(plan)"
      ></div>
    </div>

    <div
      class="plan-list-table-row feature"
      *ngFor="let feature of featuresByCategory.get(category.key)"
    >
      <div class="plan-list-table-cell label feature-label">{{ feature.value }}</div>
      <div
        class="plan-list-table-cell feature-value"
        *ngFor="let plan of plans"
        [class.highlighted]="isHighlightedPlan(plan)"
      >
        <ng-container
          *ngIf="getFeatureCell(plan, category.key, feature.name) as cell; else featureDash"
        >
          <svg-icon
            *ngIf="!cell.value && cell.enabled"
            [icon]="'check'"
            [width]="'18'"
            [height]="'18'"
          ></svg-icon>
          <span *ngIf="cell.value" class="plan-list-table-feature-value">{{ cell.value }}</span>
          <span *ngIf="!cell.value && !cell.enabled" class="plan-list-table-feature-dash">-</span>
        </ng-container>
        <ng-template #featureDash>
          <span class="plan-list-table-feature-dash">-</span>
        </ng-template>
      </div>
    </div>
  </ng-container>
</ng-template>
